import React from "react";
import style from "./Illustration.module.css";




const Illustration = () => {
    return (
        <span className={style.illustration}></span>
    )
}

export default Illustration;